import { useEffect } from 'react'
import type { ParkingLot } from '../../../map-editor-shared/store/projectStore'
import type { TemplateRelationType } from '../../../map-editor-entities/schema/templateSchema'

interface UseTemplateInitializationProps {
  template: { relationTypes?: Record<string, TemplateRelationType> } | null | undefined
  currentLotData: ParkingLot | undefined
  setMutableRelationTypes: (relationTypes: Record<string, TemplateRelationType>) => void
}

/**
 * Hook to initialize mutable relation types from the template.
 * Creates a mutable copy of the template's relation types for editing.
 */
export function useTemplateInitialization({
  template,
  currentLotData,
  setMutableRelationTypes,
}: UseTemplateInitializationProps): void {
  useEffect(() => {

    // Initialize mutable copy from template
    if (template?.relationTypes) {
      setMutableRelationTypes(template.relationTypes)
    } else {
      setMutableRelationTypes({})
    }
  }, [template, currentLotData, setMutableRelationTypes])
}
